import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowCurvedDownFlippedIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.76 12.5L10.32 17.12V10.3C10.32 7.24 12.64 4.92 15.7 4.92H20.24V6.84H15.7C13.82 6.84 12.32 8.36 12.32 10.3V17.08L16.84 12.5L18.06 13.72L11.3 20.48L4.54 13.72L5.76 12.5Z" />
    </SvgIcon>
  );
});
